import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-alert-technical',
    templateUrl: './alert-technical.component.svg',
    styleUrls: ['./alert-technical.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertTechnicalComponent {}
